// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { IStackStyles } from '@fluentui/react';

/**
 * @private
 */
export const rootLayoutStyle: IStackStyles = {
  root: {
    position: 'relative',
    height: '100%',
    width: '100%',
    padding: '0.5rem'
  }
};